import React, { useState, Fragment } from "react";
import { Tab, Menu, Transition } from "@headlessui/react";
import { SwapWidget } from "@uniswap/widgets";
import OnramperWidget from "@onramper/widget";
import { Accordion, Tooltip } from "flowbite-react";

import SampleUpload1 from "../../media/sample-upload-1.png";
import { HiOutlineInformationCircle } from "react-icons/hi";

import SelectableImage from "../SelectableImage/SelectableImage";
import Input from "../Input/Input";
import Label from "../Label/Label";
import RoundedButton from "../RoundedButton/RoundedButton";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AddFunds = () => {
  return (
    <>
      <div className="w-full  px-2 py-6 sm:px-0">
        <Tab.Group>
          <Tab.List className="flex space-x-1 rounded-xl shadow-md p-2">
            <Tab
              key={1}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-black",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-logo-green focus:outline-none focus:ring-2",
                  selected
                    ? "bg-logo-green shadow text-white"
                    : "hover:bg-white/[0.12] hover:text-black"
                )
              }
            >
              Deposit Crypto
            </Tab>
            <Tab
              key={2}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-black",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-logo-green focus:outline-none focus:ring-2",
                  selected
                    ? "bg-logo-green shadow text-white"
                    : "hover:bg-white/[0.12] hover:text-black"
                )
              }
            >
              Pay with Card
            </Tab>
            <Tab
              key={3}
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-black",
                  "ring-white ring-opacity-60 ring-offset-2 ring-offset-logo-green focus:outline-none focus:ring-2",
                  selected
                    ? "bg-logo-green shadow text-white"
                    : "hover:bg-white/[0.12] hover:text-black"
                )
              }
            >
              NFT Collatoral
            </Tab>
          </Tab.List>
          <Tab.Panels className="mt-2">
            <Tab.Panel
              key={1}
              className={classNames(
                "rounded-xl bg-white p-3",
                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                "mt-8"
              )}
            >
              <SwapWidget width="100%" />
            </Tab.Panel>
            <Tab.Panel
              key={2}
              className={classNames(
                "rounded-xl bg-white p-3",
                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2",
                "mt-8"
              )}
            >
              <div
                style={{
                  width: "440px",
                  height: "595px",
                  boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.1)",
                  borderRadius: "10px",
                  margin: "auto",
                }}
              >
                <OnramperWidget
                  API_KEY="pk_test_xmLFOq5SbjtooQhv3Ap_IH6gwssTiMSx3Ab722N_y5o0"
                  defaultCrypto="ETH"
                  defaultFiat="USD"
                  filters={{
                    onlyCryptos: ["ETH"],
                  }}
                />
              </div>
            </Tab.Panel>
            <Tab.Panel
              key={3}
              className={classNames(
                "w-full rounded-xl bg-white p-3 inline-flex flex-wrap",
                "ring-white ring-opacity-60 ring-offset-2 ring-offset-blue-400 focus:outline-none focus:ring-2"
              )}
            >
              <SelectableImage
                image={SampleUpload1}
                propertyName="Decentraland"
              />
              <SelectableImage
                image={SampleUpload1}
                propertyName="Decentraland"
              />
              <div className="mt-10 w-auto">
                <div className="mb-2">
                  <Label labelText="VALUE OF NFT" />
                </div>
                <Input
                  type="text"
                  name="property-name"
                  id="property-name"
                  placeholder="12 ETH"
                  disabled={true}
                  price={false}
                  className="w-full"
                />
              </div>
              <div className="inline-flex mt-8">
                <Tooltip
                  content="This is some cool info on fees."
                  placement="left"
                  trigger="hover"
                >
                  <HiOutlineInformationCircle className="w-6 h-6 text-slate-500" />
                </Tooltip>
                <h3 className="pl-2 text-slate-600 text-md">
                  If the property is not returned, the NFT collateral will be
                  given to the lender.
                </h3>
              </div>            
              <div className="relative container mx-auto mt-6 left-52">
                <RoundedButton outline={false} children={<h3>Add</h3>}/>  
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};
export default AddFunds;
